class PageDelegate {
    /**
     * `onChange` handler forwarded to the design-elements `Tabs`. Stores
     * the new active key in component state so the page can render the
     * matching tab content. Arrow class field so `this` stays bound to
     * the React component instance after the `Inherit` mix-in.
     *
     * @param {string} key newly-active tab key
     */
    setActiveTabKey(activeTabKey) {
        this.setState({ activeTabKey });
    }
}

export default PageDelegate;
